module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0021_19_D18_5.b985bcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0021_19_D18_5.jpg
// module id = VPdv
// module chunks = 0